import { takeLatest, delay } from 'redux-saga'
import { put, call } from 'redux-saga/effects'

import actionTypes from 'redux/actions/actionTypes'
import actions from 'redux/actions/fillInTheBlanks/sessionActions'
import callAny from 'redux/sagas/helpers/call_any'
import getAwsFile from 'sync/helpers/awsFile'
import formatError from '../helpers/error_formatter'
import {getStudentsData} from 'sync/fill_in_the_blanks/session_sync'

function *initialize(action) {
	try {
		const params = action.params
		const fileData = yield call(
			getAwsFile,
			`Presentation/${params.presentationId}/ios_ipad/${params.slideId}/config.json`,
			params.awsCredentials,
		)
		// This exported json file was used as a JSONP originally and now we need to parse it to a json file
		// that's why we are removing the `loadConfig()` method that wraps the json data itself
		const fileText = fileData.text
			.substr(0, fileData.text.length - 1)
			.substr(11)
		const fitbConfigData = JSON.parse(fileText)
		yield put(actions.configFetched(fitbConfigData))
	} catch (error) {
		yield put(actions.configFailed(formatError(error)))
	}
}

function *getStudents(action) {
	try {
		const response = yield callAny(
			getStudentsData,
			action.params.userCredentials.device_uid,
			action.params.userCredentials.rd,
			action.params.slideId,
		)
		yield put(actions.studentDataFetched(response.payload.answers))
	} catch (error) {
		// No action
	}
}

function *getSessionState(action) {
	while (true) {
		yield call(
			getStudents,
			action,
		)
		yield call(delay, 8000)
	}
}

export default [
	takeLatest(actionTypes.FILL_IN_THE_BLANKS_SESSION_INITIALIZE_ROUTE, initialize),
	takeLatest(actionTypes.FILL_IN_THE_BLANKS_SESSION_INITIALIZE_ROUTE, getSessionState),
]

export {
	initialize,
	getStudents,
}
